import {Component} from '@angular/core';
import {TabsPageContainer} from "../../uiComponents/tabsPageContainer";

@Component({
  selector: 'account-compromised-cfg-tabs',
  templateUrl: './account-compromised-configurations-tabs.component.html',
})
export class accountCompromisedCfgTabsComponent extends TabsPageContainer {
}
